// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d0b0da75","453":"31bd0061","901":"91f82f76"}[chunkId] + ".chunk.js";
};